<template>
  <v-dialog v-model="dialog" max-width="800px" persistent scrollable>
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title>
          <h4>Set Hotel Commission</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon color="black" size="30">close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card-text style="height: auto" class="px-4 pt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout>
            <v-spacer></v-spacer>
            <v-btn
              style="
                background: #000000 0% 0% no-repeat padding-box;
                box-shadow: 0px 3px 6px #00000029;
                border-radius: 7px;
                font-weight: bold;
                letter-spacing: 0.1rem;
                color: white;
              "
              color="black"
              @click="addCommission"
              v-if="loading === false && hotelCommissions.length === 0"
              >Generate commissions</v-btn
            >
          </v-layout>
          <v-data-table
            v-if="!loading"
            :headers="commissionHeaders"
            :items="hotelCommissions"
            class="elevation-1 mt-3"
          >
            <template v-slot:items="props">
              <tr>
                <td class="pa-3 text-xs-center">
                  <v-text-field
                    :disabled="saving"
                    solo
                    v-model="formEdit.service_type"
                    hide-details
                    v-if="editingIndex == props.index"
                  ></v-text-field>
                  <span v-else>{{ props.item.service_type }}</span>
                </td>
                <td class="pa-3 text-xs-center">
                  <v-text-field
                    :disabled="saving"
                    solo
                    v-model="formEdit.unit"
                    hide-details
                    v-if="editingIndex == props.index"
                  ></v-text-field>
                  <span v-else>{{ props.item.unit }}</span>
                </td>
                <td class="pa-3 text-xs-center">
                  <v-text-field
                    :disabled="saving"
                    solo
                    v-model="formEdit.value"
                    hide-details
                    v-if="editingIndex == props.index"
                  ></v-text-field>
                  <span v-else>{{ props.item.value }}</span>
                </td>
                <td class="pa-3 text-xs-center">
                  <v-switch
                    v-model="formEdit.is_active"
                    color="primary"
                    hide-details
                    v-if="editingIndex == props.index"
                  ></v-switch>
                  <v-icon
                    v-else
                    :color="props.item.is_active ? 'green' : 'red'"
                    >{{
                      props.item.is_active ? "mdi-check" : "mdi-close"
                    }}</v-icon
                  >
                </td>
                <td class="text-xs-center">
                  <v-btn
                    icon
                    @click="toggleEdit(props.item, props.index)"
                    :loading="saving && editingIndex == props.index"
                  >
                    <v-icon small>{{
                      editingIndex != props.index ? "edit" : "save"
                    }}</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
            class="my-3"
          ></v-progress-circular>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    hotelData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      commissionHeaders: [
        {
          text: "Service Type",
          value: "service_type",
          sortable: false,
          align: "center",
        },
        { text: "Unit", value: "unit", sortable: false, align: "center" },
        { text: "Value", value: "value", sortable: false, align: "center" },
        {
          text: "Active",
          value: "is_active",
          sortable: false,
          align: "center",
        },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      saving: false,
      hotelCommissions: [],
      loading: false,
      editingIndex: null,
      formEdit: {
        service_type: "",
        unit: "",
        value: "",
        is_active: "",
      },
    };
  },
  computed: {},
  watch: {
    async dialog() {
      if (this.dialog) {
        await this.fetchCommissions();
      }
    },
  },
  methods: {
    ...mapActions({
      fetchHotelCommissions: "hotel/fetchHotelCommissions",
      createHotelCommissions: "hotel/createHotelCommissions",
      updateHotelCommission: "hotel/updateHotelCommission",
    }),
    async fetchCommissions() {
      this.loading = true;
      let result = await this.fetchHotelCommissions(this.hotelData.hotel_id);
      if (result) {
        this.hotelCommissions = result.commissions;
      }
      this.loading = false;
    },
    closeDialog() {
      this.$emit("close", false);
    },
    async addCommission() {
      const newCommissions = [
        {
          service_type: "Food",
          unit: "%",
          value: "10",
          is_active: true,
          hotel_id: this.hotelData.hotel_id,
        },
        {
          service_type: "Messenger",
          unit: "%",
          value: "10",
          is_active: true,
          hotel_id: this.hotelData.hotel_id,
        },
      ];

      const response = await this.createHotelCommissions(newCommissions);
      if (response) {
        this.hotelCommissions.push(...response);
      }
    },
    async toggleEdit(item, index) {
      if (this.editingIndex === index) {
        // Save changes
        this.saving = true;
        try {
          const updatedCommission = await this.updateHotelCommission(
            this.formEdit
          );
          if (updatedCommission) {
            this.hotelCommissions.splice(index, 1, updatedCommission);
          }
        } catch (error) {
          console.error("Failed to update commission:", error);
        }
        this.saving = false;
        this.editingIndex = null;
      } else {
        this.formEdit = { ...item };
        this.editingIndex = index;
      }
    },
  },
};
</script>

<style>
/* Add any necessary styles here */
</style>
